class ChooseCategoryFullModalController {

    constructor() {

        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());
        //ACTION = 'CHALLENGE'|| 'ADDQUESTION' || 'EDITQUESTION' || 'SINGLEGAME'
        this.action = undefined;
        var that = this;
        $(document).on("click", '.choose-category-link:not(.btn-disabled)', function() {

            var hasChildren = $(this).attr('data-haschildrens') === 'true';
            var categoryId = $(this).attr('data-id');
            var categoryName = $(this).attr('data-name');
            var categoryIcon = $(this).attr('data-icon');
            var categoryColor = $(this).attr('data-color');

            if (!hasChildren) {

                if(that.action =='SINGLEGAME'){
                    baseController.closeSimpleMenu();
                    api.createNewGame(world.token, categoryId);
                }

                if(that.action =='EDITQUESTION'){
                    api.getReviewQuestions(world.token,categoryId,25,0);
                }

                if(that.action =='ADDQUESTION'){
                    let addQuestionController = new AddQuestionFullModalController();
                    addQuestionController.draw(categoryId, categoryName, categoryIcon, categoryColor);
                    ga('send', 'pageview', analytics.GA_SCREEN_SELECT_CATEGORIES_WIKIQUIZ);
                }

                if(that.action =='CHALLENGE'){
                    worldHomeController.setChallengeRequest(null,categoryId,null,null);
                    chooseBetFullModalController.draw();
                }

            } else { //Tiene hijos
                baseController.stackSimpleMenu({text: categoryName,backAction:'closeCategory'});
                api.getnewGameCategories(world.token, categoryId, that.action, hasChildren);
            }

        });
    }
    
    draw(result, question_category_parent_id, action, isChildren=false) {

        this.action = action;
        if (this.action == 'ADDQUESTION') {
            this.template = Handlebars.compile($("#chooseCategoryAddFullModal").html());
        } else if (this.action == 'EDITQUESTION') {
            this.template = Handlebars.compile($("#chooseCategoryReviewFullModal").html());
        } else {
            this.template = Handlebars.compile($("#chooseCategoryFullModal").html());
        }

        // Si ya tengo categorias guardadas en la clase World
        if(world.categories) {
            // Se añaden las nuevas, se elimiann duplicados y se dejan ordenadas de nuevo
            $.each(result.categories, function(index, category) {
                world.categories.push(category)
            });
            world.categories = $.unique(world.categories);
            world.categories = world.categories.sort(dynamicSort('order','category'));
        } else {
            world.categories = result.categories;
        }

        // Convert progress
        for (var i = 0; i < result.categories.length; i++) {
            var category = result.categories[i].category;
            category.progressPercent = Math.floor(parseFloat(category.progress)*100);
        }

        var total_pending_questions = result.categories.reduce((sum, elem) => sum + elem.category.pending_questions, 0);

        var context = {
            question_category_parent_id: question_category_parent_id,
            world: world,
            categories: result.categories.sort(dynamicSort('order','category')),
            total_pending_questions: total_pending_questions
        };

        baseController.resetStackableOrder();
        if (!isChildren) {
            baseController.stackSimpleMenu({title: 'TR_SELECCIONA_UNA_CATEGORIA', icon: 'back'}, this.menuTemplate);
        }
        baseController.stackSimpleContent(this.template, context, 'GAME');

        if(action == 'ADDQUESTION'){
            $('#choose-category-random-row').hide();
        }

        $('.choose-category-progress').each((i, elem) => {
            elem = $(elem);
            var progress = parseInt(elem.attr('data-progress'));
            this.createProgressChart(elem, progress);
        });

        let height = 40;

        if ($(window).width() <= 420) {
            height = 30;
        }

        $('.choose-category-box-content-name').dotdotdot({
            height: height,
            watch: 'true',
            truncate: 'letter'
        });

        ga('send', 'pageview', analytics.GA_SCREEN_SELECT_CATEGORY);
    }

    createProgressChart(elem, progress) {

        elem.highcharts({
            chart: {
                spacing: [0,0,0,0],
                margin: [0,0,0,0],
                backgroundColor: 'transparent'
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ''
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    size: '100%',
                    dataLabels: {
                        enabled: false
                    },
                    borderColor: null,
                    center: ['50%', '50%'],
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            series: [{
                type: 'pie',
                innerSize: '95%',
                data: [
                    ['', progress],
                    ['', 100-progress]
                ],
                colors: [
                    '#FFF', 'rgba(255,255,255,0.4)'
                ]
            }]
        });

    }

}
